<template>
  <section class="resource--basic">
    <v-container>
      <v-layout column>
        <v-flex sm12>
          <div class="resource--header-grid">
            <div class="resource--header-col-9">
              <div class="d-flex">
                <v-text-field
                  label="Search Resource By Name"
                  v-model="opts.name"
                  @keyup.enter="query"
                  style="width: 90%;"
                />
                <div>
                  <v-btn icon color="primary" @click="query">
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div>
              <v-btn outline color="primary" to="/authentication/create">
                <v-icon left>add</v-icon>Create New
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
    <section>
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12>
            <div class="resource--list-grid">
              <div class="resource--span-col-4">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="resource--text-style">NAME</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="resource--span-col-4">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="resource--text-style">ID</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div>
                <v-list-tile-action>
                  <v-btn icon color="primary" disabled>
                    <v-icon>menu</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-divider/>
    <section v-if="loaded">
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12 v-for="(resource) in resources.docs" :key="resource.id">
            <v-card>
              <div class="resource--list-grid">
                <div class="resource--span-col-4">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-transform: capitalize;">
                        <router-link
                          :to="`/authentication/resource/${resource.id}`"
                        >{{resource.name}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="resource--span-col-4">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ resource.id }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div>
                  <v-list-tile-action>
                    <v-menu bottom left nudge-top="-40">
                      <v-btn slot="activator" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/authentication/resource/${resource.id}`">
                              <v-icon>remove_red_eye</v-icon>&nbsp;
                              View
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- UPDATE THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/authentication/resource/${resource.id}?update=1`">
                              <v-icon>edit</v-icon>&nbsp;
                              Update
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- DELETE THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/authentication/resource/${resource.id}?delete=1`">
                              <v-icon>delete</v-icon>&nbsp;
                              Delete
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm12 v-if="(resources.docs || []).length < 1">
            <div class="text-xs-center" style="margin: 50px auto;">
              <h2 style="font-size: 40px;">No Resources Found!</h2>
            </div>
          </v-flex>
        </v-layout>

        <div class="text-xs-center">
          <v-pagination :length="resources.pages" :total-visible="8" v-model="opts.page"/>
        </div>
      </v-container>
    </section>
    <section v-else>
      <Loader/>
    </section>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
import Loader from "../../components/loader";
import generateSnackbarError from "../generateSnackbarError";
export default {
  components: {
    Loader
  },
  data() {
    return {
      loaded: false,
      resources: {},
      opts: {
        name: "",
        page: 1
      }
    };
  },
  methods: {
    getResources(variables = {}) {
      const obs = coreClient.watchQuery({
        query: gql`
          query Resources($name: String, $page: Int) {
            Resources(name: $name, page: $page) {
              total
              pages
              page
              docs {
                id
                name
              }
            }
          }
        `,
        variables,
        fetchPolicy: "cache-and-network"
      });

      obs.subscribe(
        ({ data, loading }) => {
          this.loaded = !loading;
          if (data) {
            this.resources = data.Resources;
          }
        },
        err => {
          this.loaded = true;
          this.$store.commit(
            "updateSnackbar",
            generateSnackbarError(err, "Resources")
          );
        }
      );
    },
    async query() {
      await this.getResources(this.opts);
    }
  },
  async mounted() {
    let { query } = this.$route;
    this.opts.page = Number(query.page) || this.opts.page;

    await this.query();

    this.$watch("opts.page", async page => {
      this.$router.push({
        name: "Resources",
        query: { ...query, page: this.opts.page }
      });

      await this.query();
    });

    this.$watch("opts.name", async val => {
      if (val === "") {
        await this.query();
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Resources.styl';
</style>
